import React from 'react'

export const ConstructorProductMeta = ({ id, title }) => {
  return <meta data-product-id={id} data-product-name={title} />
}
